module.exports = __webpack_public_path__ + "static/media/viacoin.2a5ea0f8.svg";